import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';
import Atention from 'scenes/Producer/Product/MyProducts/components/Atention';
import ShareableLinks from 'scenes/Producer/Product/MyProducts/components/ShareableLinks';
import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  copiedCheckout?: () => void;
  product: IProduct;
  currentUser?: IUser;
}

const QuickViewLinks = ({ product, copiedCheckout }: IProps) => {
  return (
    <ActionCollapse title='Links' icon={<Icon.Link2 size={16} />}>
      <ShareableLinks copiedCheckout={copiedCheckout} productId={product.hash ?? product.id} />
      <Atention />
    </ActionCollapse>
  );
};

export default QuickViewLinks;
